<template>
  <v-card
    v-if="ligneRobsIsLoading === false && commandesIsLoading === false"
    flat
  >
    <v-card-text>
      <v-data-table
        :headers="ligneHeaders"
        :items="ligneRobs"
        item-key="id"
        :item-class="itemRowClass"
        @dblclick:row="open"
        :items-per-page="-1"
        :hide-default-footer="true"
      >
        <template #top>
          <v-row>
            <v-spacer />
            <v-chip class="text-h3 font-weight-bold mb-4">
              <span class="color_success--text">{{ getMontant().fait }}</span>
              /
              <span
                :class="
                  getMontant().fait === getMontant().total
                    ? 'color_success--text'
                    : 'color_danger--text'
                "
                >{{ getMontant().total }}
              </span>
            </v-chip>
          </v-row>
        </template>
        <template #[`item.valeur_devise_origine`]="{ item }">
          {{ item.valeur_devise_origine }}
        </template>
        <template #[`item.statut`]="{ item }">
          <v-icon v-if="item.statut" color="color_success">
            mdi-check-circle-outline
          </v-icon>
          <v-icon v-else color="color_danger"> mdi-alert-outline</v-icon>
        </template>
        <template #[`item.facturette`]="{ item }">
          <v-icon v-if="item.facturette" color="color_success">
            mdi-check-circle-outline
          </v-icon>
          <template v-else>
            <v-icon color="color_danger"> mdi-alert-outline</v-icon>
          </template>
        </template>
        <template #[`item.relance`]="{ item }">
          <v-icon v-if="item.relance === 'DR'" color="color_primary">
            mdi-check-circle-outline
          </v-icon>
          <v-icon v-if="item.relance === 'SB'" color="color_warning">
            mdi-send-circle-outline
          </v-icon>
        </template>
      </v-data-table>
      <v-dialog v-model="dialog" persistent scrollable fullscreen hide-overlay>
        <choice-command v-model="ligne" :closeDialog="closeDialog" />
      </v-dialog>
    </v-card-text>
  </v-card>
</template>

<script>
import { generalMixin } from "@/mixins/general";
import { cardMixin } from "@/mixins/cardMixin";
import { ligneRobMixin } from "@/mixins/ligneRob";
import { commandeMixin } from "@/mixins/commande";
import choiceCommand from "@/components/choiceCommand";
import { libUtilMixin } from "@/mixins/libUtilMixin";
import { userMixin } from "@/mixins/user";

export default {
  name: "VueShowCarteLigne",
  components: {
    choiceCommand,
  },
  mixins: [
    generalMixin,
    cardMixin,
    ligneRobMixin,
    commandeMixin,
    libUtilMixin,
    userMixin,
  ],
  data() {
    return {
      ligne: {},
      dialog: false,
      search: "",
    };
  },
  computed: {
    ligneHeaders() {
      let a = [
        {
          text: this.$t("ligneRob.statut"),
          align: "start",
          sortable: true,
          value: "statut",
          class: "color_thead  lighten-2 white--text",
        },
        {
          text: this.$t("ligneRob.facturette"),
          align: "start",
          sortable: true,
          value: "facturette",
          class: "color_thead lighten-2  white--text",
        },
        {
          text: this.$t("ligneRob.num"),
          align: "start",
          sortable: true,
          value: "num",
          class: "color_thead lighten-2  white--text",
        },
        {
          text: this.$t("ligneRob.date_emission"),
          align: "start",
          sortable: true,
          value: "date_emission",
          class: "color_thead lighten-2  white--text",
        },
        {
          text: this.$t("ligneRob.type"),
          align: "start",
          sortable: true,
          value: "type",
          class: "color_thead lighten-2  white--text",
        },
        {
          text: this.$t("ligneRob.montantTTC"),
          align: "start",
          sortable: true,
          value: "montant_ttc",
          class: "color_thead  lighten-2 white--text",
        },
        {
          text: this.$t("ligneRob.fournisseur"),
          align: "start",
          sortable: true,
          value: "fournisseur",
          class: "color_thead lighten-2 white--text",
        },
        {
          text: this.$t("ligneRob.montantDeviseOrigine"),
          align: "start",
          sortable: true,
          value: "valeur_devise_origine",
          class: "color_thead lighten-2 white--text",
        },
      ];
      if (this.user !== null && this.user.is_dr)
        a.push({
          text: this.$t("ligneRob.relance"),
          align: "start",
          sortable: true,
          value: "relance",
          class: "color_thead lighten-2 white--text",
        });
      return a;
    },
  },
  methods: {
    itemRowClass: function (item) {
      return item.annule ? "grey--text text--lighten-1" : "";
    },
    closeDialog() {
      this.updateLigneRob({
        id: this.ligne.id,
        values: {
          annule: this.ligne.annule,
          facturette: this.ligne.facturette,
          statut: this.ligne.statut,
          commentaires: this.ligne.form,
        },
        list: this.ligneRobs,
      });
      this.getCommandes(this.paramsRob.structureId);
      this.dialog = false;
    },
    open(evt, { item }) {
      this.ligne = item;
      this.dialog = true;
    },
    getMontant() {
      let fait = 0;
      let total = 0;
      this.ligneRobs.forEach(function (item) {
        fait += item.statut && !item.annule ? item.montant_ttc : 0;
        total += !item.annule ? item.montant_ttc : 0;
      });
      return { total: this.arrondi2(total), fait: this.arrondi2(fait) };
    },
    evalParams() {
      if (this.paramsRob.ligneId !== null) {
        this.ligne = this.ligneRobs.find(
          (x) => x.id === this.paramsRob.ligneId
        );
        this.paramsRob.ligneId = null;
        this.dialog = true;
      }
    },
  },
  watch: {
    ligneRobsIsLoading(cur) {
      if (!cur) this.evalParams();
    },
  },
};
</script>

<style scoped></style>
